import { mapActions } from 'vuex'
import i18n from '@/i18n'
import AutocompleteComponent from "@/components/commons/autocomplete/AutocompleteComponent.vue";
import { stateService } from "@/services/state.service";


export default {
    name: 'AgriculturalObjetiveTabComponent',
    components: {
        AutocompleteComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        },
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,
        selectedRus: null,
        loading: false,
        states: [],
        values: [],
        actualValue: null,
        tableHeaders: [],
        disabledBtn: false,
        selectedState: null,
        selectedValue: null,
        validationRules: {
            required: (value) => !!value || value === 0 || `${i18n.t('required')}`,
            validateSpecialChartsNumber: (value) => /^[0-9.]+$/.test(value) || `${i18n.t('goals.validateForm.invalidSpecialChars')}`,
            validateDecimals: (value) => /^(?=.*\d)\d*(?:\.\d{1,2})?$/.test(value) || `${i18n.t('goals.validateForm.invalidDecimalPlacesNumber')}`,
        },
        valueValidationErrorMessage: '',

    }),
    computed: {},
    created() {
    },
    async mounted() {
        this.tableHeaders = [
            {text: '', value: 'actions'},
            {text: "Estado", value: 'id'},
            {text: "Valor", value: 'value'},
        ];
    },

    methods: {
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),

        addObjetiveConfig() {
            this.model.tableData.push({id: null, value: null});
        },

        deleteObjetiveConfig(tableProps) {
            this.model.tableData.splice(this.model.tableData.indexOf(tableProps.item), 1);
        },

        stateSelectedFunction(newValue, item) {
            item.id = newValue ? newValue.id : '';
            this.validateForm();
        },

        validateForm() {
            let valid = !!this.model.tableData.length;
            this.model.tableData.forEach(data => {
                if (!data.value || !data.id) {
                    valid = false;
                } else {
                    let regex = /^[0-9.]+$/
                    if (!regex.test(data.value)) {
                        valid = false;
                    } else {
                        regex = /^(?=.*\d)\d*(?:\.\d{1,2})?$/
                        if (!regex.test(data.value)) {
                            valid = false;
                        }
                    }
                }
            });
            this.model.validForm = valid;
        },

        async getStates(enterpriseId) {
            this.model.tableData = [];
            this.loading = true;
            this.states = [];
            if (enterpriseId) {
                let statesResult = await stateService.findAllForSelectorByEnterprise(enterpriseId);
                let locale = localStorage.getItem('locale');
                if (statesResult.length) {
                    this.states = statesResult.map(state => ({
                        id: state._id,
                        name: state.name[locale],
                    }));
                    this.states.sort(function sort(a, b) {
                        const nameA = a.name.toLowerCase()
                        const nameB = b.name.toLowerCase()
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        return 0;
                    });
                }
            }
        }
    },
    watch: {
        'model.enterpriseId': {
            deep: true,
            immediate: true,
            handler: function (newValue) {
                this.getStates(newValue).finally(() => {
                    this.loading = false;
                    this.validateForm();
                });
            }
        }
    }
}
